<template>
    <div>
      <custom-modal :title="title ? title : ''" v-model="show" @close="close()" width="75%" v-if="modal">
        <div id="container">
            <vue-pdf-app :pdf="url"></vue-pdf-app>
        </div>
      </custom-modal>
      <div id="container" v-else>
            <vue-pdf-app :pdf="pdf_url"></vue-pdf-app>
        </div>
    </div>
</template>

<script>
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
import CustomModal from './CustomModal.vue';

export default {
  components: { CustomModal, VuePdfApp },
  props: {
    modal: {
      default: true,
    },
    pdf_url: {
      default: null,
    },
  },
  data: () => ({
    title: '',
    show: false,
    url: '',
  }),
  methods: {
    open(url, title) {
        this.title = title
        // this.url = url.replace('https', 'http')
        this.url = url
        this.show = true
    },
    close() {
        this.resetData()
    },
    resetData() {
      Object.assign(this.$data, this.$options.data())
    },
  },
}
</script>

<style>
#container {
    /* height: 500px; */
    height: 75vh;
}
</style>